import PropTypes from 'prop-types';
import React from 'react';

class FilterButtonGroup extends React.Component {
  handleButtonClick = (value) => () => {
    const { handleClickEvent } = this.props;

    if (handleClickEvent) {
      handleClickEvent(value);
    }
  }

  renderButtons = () => {
    const { filterConfig, value } = this.props;

    if (!filterConfig) {
      return [];
    }

    return [filterConfig.map((filterConfigItem) =>
      (<div className="btn-group" key={filterConfigItem.filterValue}>
        <button
          type="button"
          className={'btn btn-default' + (filterConfigItem.filterValue === value ? ' active' : '')}
          onClick={this.handleButtonClick(filterConfigItem.filterValue)}
          value={filterConfigItem.filterValue}
        >
          {filterConfigItem.filterTitle}
        </button>
       </div>)
    )];
  };

  render() {
    return (
      <div
        className="btn-group-justified btn-group"
        role="group"
        id={this.props.id}
      >
        {this.renderButtons()}
      </div>
    );
  }
}

FilterButtonGroup.propTypes = {
  handleClickEvent: PropTypes.func,
  filterConfig: PropTypes.array,
  value: PropTypes.string,
  id: PropTypes.string,
};

export default FilterButtonGroup;